import { render, staticRenderFns } from "./card-gatorz-grid-item.vue?vue&type=template&id=143224b8&scoped=true&"
import script from "./card-gatorz-grid-item.vue?vue&type=script&lang=js&"
export * from "./card-gatorz-grid-item.vue?vue&type=script&lang=js&"
import style0 from "./card-gatorz-grid-item.vue?vue&type=style&index=0&id=143224b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143224b8",
  null
  
)

export default component.exports